module.exports = __webpack_public_path__ + "img/icon_coordinates4.00d5e7a1.png";